import base from './base';

const avatar = {
  MuiAvatar: {
    styleOverrides: {
      root: {
        width: 32,
        height: 32,
        borderRadius: base.shape.borderRadius,
        marginRight: '6px',
      },
    },
  },
};

export default avatar;
